import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { is, isNil } from 'ramda';

const Title = ({ title, icon, iconSize = [], iconOffset, backTo, filter, afterIcon, infoTitle = '', titleClassName = '' }) => {
  const history = useHistory();
  const isImageIcon = is(String, icon);
  const IconTag = isImageIcon ? 'img' : 'span';
  const [iconWidth, iconHeight] = iconSize;

  const iconStyle = {
    top: `${iconOffset}px`,
    ...(isImageIcon
      ? {
        width: `${iconWidth}px`,
        height: `${iconHeight}px`,
        filter
      }
      : {
        fontSize: iconWidth ? `${iconWidth}px` : undefined,
        lineHeight: 1
      })
  };

  return (
    <div className="flex items-center">
      {!isNil(icon) && (
        <IconTag
          {...(isImageIcon ? { src: icon, alt: 'Icône descriptive' } : {})}
          className={`mr-10px relative${isImageIcon ? '' : ' inline-flex items-center'}`}
          // eslint-disable-next-line no-restricted-syntax
          style={iconStyle}
        >
          {!isImageIcon ? icon : null}
        </IconTag>
      )}
      {!isNil(backTo) && (
        <ArrowLeftOutlined className="btn-return mr-5" onClick={() => history.push(backTo)} />
      )}
      {afterIcon}
      <h4 className={`font-bold text-lg uppercase mb-0 ${titleClassName}`}>
        {title}&nbsp;
      </h4>
      {infoTitle && infoTitle()}
    </div>
  );
};

Title.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  afterIcon: PropTypes.node,
  titleClassName: PropTypes.string
};

export default Title;
